import * as React from "react";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Logo from "../../assets/LogoSemFundo.png";
import userImg from "../../assets/userMenu.svg";
import Style from "../Home/home.module.scss";
import LogoutIcon from '@mui/icons-material/Logout';
import { MenuItem } from "@mui/material";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Popover } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import { useContext } from "react";
import { AppProvider } from "../../ContextApi/AppProvider";
import { User } from "../../Models/User";

const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function AppHome() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const contextApi = useContext(AppProvider);
  const [openCadastros, setOpenCadastros] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const openPopover = Boolean(anchorEl);
  const popoverId = openPopover ? "popover-actions" : undefined;
  

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClickCadastros = () => {
    setOpenCadastros(!openCadastros);
  };

  const openUserActions = (
    event: React.MouseEvent<HTMLElement>,
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const handleEditAction = () => {
    // Implemente a lógica para a ação de edição aqui
  };

  const handleLogoutAction = () => {
    sessionStorage.clear();
    navigate('/')
  };

  const handleViewAction = () => {
  };

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          position="fixed"
          open={open}
          style={{
            backgroundImage:
              "radial-gradient(circle at left, transparent 85%, rgba(242, 90, 36, 0.5)), linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(255, 255, 255, 0.5))",
            backgroundColor: "#000000",
          }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                justifyContent: "flex-start",
                marginRight: 5,
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon fontSize="large" />
            </IconButton>
            <div className={Style.logoHeader}>
              <div>
                <img
                  src={Logo}
                  alt="Logo WRPneus"
                  className={Style.img}
                ></img>
              </div>
              <div className={Style.userMenu}>
                <img
                  src={userImg}
                  alt="User Menu"
                  onClick={(event) => openUserActions(event)}
                />
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open} sx={{
          ".MuiPaper-root": {
            backgroundColor: "#F7F2FA",
          },
        }} >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List>
            <ListItem
              key="Pedidos"
              component={Link}
              to="/app/pedidos"
              disablePadding
              sx={{
                '&:hover': {
                  backgroundColor: "#d2cdd2",
                },
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <RequestPageIcon fontSize="large" sx={{ color: "#9D7063" }} ></RequestPageIcon>
                </ListItemIcon>
                <ListItemText primary="Pedidos" sx={{ color: "black" }} />
              </ListItemButton>
            </ListItem>
            <ListItem
              key="Clientes"
              component={Link}
              to="/app/clientes"
              disablePadding
              sx={{
                '&:hover': {
                  backgroundColor: "#d2cdd2",
                },
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <PeopleAltIcon fontSize="large" sx={{ color: "#9D7063" }} ></PeopleAltIcon>
                </ListItemIcon>
                <ListItemText primary="Clientes" sx={{ color: "black" }} />
              </ListItemButton>
            </ListItem>
            <ListItem
              key="Estoque"
              component={Link}
              to="/app/estoque"
              disablePadding
              sx={{
                '&:hover': {
                  backgroundColor: "#d2cdd2",
                },
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <InventoryIcon fontSize="large" sx={{ color: "#9D7063" }}></InventoryIcon>
                </ListItemIcon>
                <ListItemText primary="Estoque" sx={{ color: "black" }} />
              </ListItemButton>
            </ListItem>
            {/* <ListItem
              key="Fornecedor"
              component={Link}
              to="/app/fornecedor" 
              disablePadding
              sx={{'&:hover': {
                backgroundColor: "#d2cdd2",
              },}}
            >
              <ListItemButton>
                <ListItemIcon>
                  <FactoryIcon fontSize="large" sx={{color:"#9D7063"}}></FactoryIcon>
                </ListItemIcon>
                <ListItemText primary="Fornecedor" sx={{color:"black"}}/>
              </ListItemButton>
            </ListItem> */}
            <ListItem
              key="Busines"
              component={Link}
              to="/app/negocio"
              disablePadding
              sx={{
                backgroundColor: "#d2cdd2",
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <BusinessCenterIcon fontSize="large" sx={{ color: "#9D7063" }}></BusinessCenterIcon>
                </ListItemIcon>
                <ListItemText primary="Negócio" sx={{ color: "black" }} />
              </ListItemButton>
            </ListItem>
            <ListItem
              key="Cadastros"
              component={Link}
              to="/app/cadastros"
              disablePadding
              sx={{
                '&:hover': {
                  backgroundColor: "#d2cdd2",
                },
              }}
            >
              <ListItemButton>
                <ListItemIcon>
                  <AddCircleIcon fontSize="large" sx={{ color: "#9D7063" }}></AddCircleIcon>
                </ListItemIcon>
                <ListItemText primary="Cadastros" sx={{ color: "black" }} />
              </ListItemButton>
            </ListItem>
          </List>
          <Divider />
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3, padding: 0 }}>
          <DrawerHeader />
          <Outlet />
        </Box>
      </Box>
      <Popover
        id={popoverId}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem onClick={() => handleViewAction()}>
          <VisibilityIcon style={{ marginRight: "8px" }} />
          Visualizar
        </MenuItem>
        <MenuItem onClick={() => handleEditAction()}>
          <EditIcon style={{ marginRight: "8px" }} />
          Editar
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handleLogoutAction()}>
          <LogoutIcon style={{ marginRight: "8px" }} />
          Sair
        </MenuItem>
      </Popover>
    </>
  );
}
